import { render, staticRenderFns } from "./form-post-create-mobilestepper.vue?vue&type=template&id=5456dfe4&scoped=true&"
import script from "./form-post-create-mobilestepper.vue?vue&type=script&lang=js&"
export * from "./form-post-create-mobilestepper.vue?vue&type=script&lang=js&"
import style0 from "./form-post-create-mobilestepper.vue?vue&type=style&index=0&id=5456dfe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5456dfe4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBottomNavigation,VBtn,VForm,VIcon,VSpacer,VStepper,VStepperContent,VStepperItems,VTextField})
